module.exports = __webpack_public_path__ + "school/img/chuanGxThemeBg.0827cd86.jpg";